var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 109,
    viewBox: "0 0 550 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2251_28138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 550,
    height: 109
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 550,
    height: 109,
    rx: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2251_28138)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M550 79.0435L527.083 74.6522C504.167 70.2609 458.333 61.4783 412.5 59.2826C366.667 57.087 320.833 61.4783 275 72.4565C229.167 83.4348 183.333 101 137.5 101C91.6668 101 45.8335 83.4348 22.9168 74.6522L0.000158654 65.8696L0.000165866 0L22.9168 1.59958e-06C45.8335 3.19917e-06 91.6668 6.39833e-06 137.5 9.5975e-06C183.333 1.27967e-05 229.167 1.59958e-05 275 1.9195e-05C320.833 2.23942e-05 366.667 2.55933e-05 412.5 2.87925e-05C458.333 3.19917e-05 504.167 3.51908e-05 527.083 3.67904e-05L550 3.839e-05V79.0435Z",
    fill: "#25233B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 79.0435L22.9168 74.6522C45.8335 70.2609 91.6666 61.4783 137.5 59.2826C183.333 57.087 229.167 61.4783 275 72.4565C320.833 83.4348 366.667 101 412.5 101C458.333 101 504.167 83.4348 527.083 74.6522L550 65.8696L550 3.839e-05L527.083 3.67904e-05C504.167 3.51908e-05 458.333 3.19917e-05 412.5 2.87925e-05C366.667 2.55933e-05 320.833 2.23942e-05 275 1.9195e-05C229.167 1.59958e-05 183.333 1.27967e-05 137.5 9.5975e-06C91.6668 6.39833e-06 45.8335 3.19917e-06 22.9168 1.59958e-06L0.000165866 0L0 79.0435Z",
    fill: "#25233B",
    fillOpacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.cfef7b5ae87bac84d56c5b97e3bf4aef.svg";
export { ForwardRef as ReactComponent };